import React from 'react'
import PropTypes from 'prop-types'
import { Input, Button, Icon } from 'loyal-react'
import { Link, withRouter } from 'react-router-dom'
import yn from 'yn'
import MediaQuery from 'react-responsive'

import OnDemandLiveRegion from 'on-demand-live-region'

const showMsgError = (error) => {
  setTimeout(function () {
    const liveRegionDelayed = new OnDemandLiveRegion({
      delay: 300,
      level: 'assertive',
      parent: '#error-username'
    })
    liveRegionDelayed.say(error)
  }, 2000)
}

const UsernameBox = ({
  handleContinue,
  handleChange,
  username,
  usernamePolicy,
  allowSignUp,
  isLookingUpUsername,
  isHidden,
  error,
  location: { search }
}) => {
  const isValid = username && username.length > 0
  const inputProperties = {}

  switch (usernamePolicy) {
    case 'CPF':
      if (!isHidden) {
        inputProperties.mask = [/[0-9]/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]
      }
      inputProperties.value = username.replace(/\D/g, '')
      inputProperties.label = 'qual é o seu CPF?'
      inputProperties.minLength = '15'
      inputProperties.maxLength = '15'
      break
    case 'CNPJ':
      if (!isHidden) {
        inputProperties.mask = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/]
      }
      inputProperties.value = username.replace(/\D/g, '')
      inputProperties.label = 'Qual é o seu CNPJ?'
      inputProperties.minLength = '18'
      inputProperties.maxLength = '18'
      break
    default:
      inputProperties.value = username
      inputProperties.label = process.env.RAZZLE_DEFAULT_USERNAME_LABEL || 'Login'
      break
  }

  const handleKeyPress = (e, element) => {
    let inputIndex = element
    const inputOrder = [
      'username',
      'btnContinue'
    ]

    let isDisabled = true

    while (isDisabled) {
      if (inputOrder[inputIndex] === 'btnContinue') {
        isDisabled = false
      } else {
        let input = document.querySelector(`#${inputOrder[inputIndex]}`)
        if (input.getAttribute('disabled') === null || input.getAttribute('disabled') === undefined) {
          isDisabled = false
        } else {
          inputIndex++
        }
      }
    }

    // eslint-disable-next-line no-unused-expressions
    if (e.key === 'Enter') {
      if (inputIndex) {
        e.target.blur()
        document.querySelector(`#${inputOrder[inputIndex]}`) &&
          document.querySelector(`#${inputOrder[inputIndex]}`).focus()
      }
    }
  }

  return (
    <>
      <div id='box-login' className={`box-login row pb-4 ${isHidden ? 'd-none' : 'accesibility-active-h1-focus'}`}>
        <div className='col-12 col-md-6 col-lg-5 mr-auto ml-auto py-3 px-3 radius bg-white border border-color-ui-3 pb-5 mb-5'>
          <div className='row'>
            <MediaQuery maxWidth={767}>
              <div className='col-6 mb-2'>
                <p className='txt-body-sm'>
                  <a id='image-link' href={`https://${process.env.RAZZLE_APP_TENANT_DOMAIN}`} className='txt-body-sm d-block' aria-label='Voltar para a home' role='button'>
                    <Icon className='icon icon_left_app' />
                  </a>
                </p>
              </div>
              <div className='col-6 mb-2 close-login'>
                <p className='txt-body-sm'>
                  <a href={`https://${process.env.RAZZLE_APP_TENANT_DOMAIN}`} className='txt-body-sm d-flex justify-content-end' aria-label='Fechar tela de login' role='button'>
                    <Icon className='icon icon_menu_app_close' />
                  </a>
                </p>
              </div>
            </MediaQuery>
            <div className='col-12'>
              <h1 className='h1 login-title color-brand-1 txt-font-body mb-1'>
                {
                  process.env.RAZZLE_MESSAGE_LOGIN_TITLE
                  ? process.env.RAZZLE_MESSAGE_LOGIN_TITLE
                  : `Bem-Vindo(a) ao ${process.env.RAZZLE_TITLE}!`
                }
              </h1>
              {
                !yn(process.env.RAZZLE_MESSAGE_LOGIN_HIDE) ? 
                (<h2 className='txt-body-sm color-ui-2 txt-font-body mb-1'>acesse sua conta { allowSignUp ?  'ou cadastre-se' : ''}</h2>)
                : ''
              }
              <div className='row'>
                <Input
                  {...inputProperties}
                  id='username'
                  className={`col-12 col-md-12 mt-1`}
                  childrenClassName={`has-content ${error && 'error'}`}
                  onChange={(e) => handleChange(e)}
                  onKeyPress={(e) => handleKeyPress(e, 1)}
                  type={'text'}
                  inputMode={['CPF', 'CNPJ'].includes(usernamePolicy) ? 'numeric' : 'text'}
                  name='username'
                  autoComplete='off'
                  aria-describedby={error && 'error-username'}
                  aria-required
                />
                {error && (
                  <div className='message message-error'>
                    <small id='error-username' aria-hidden='true' className='txt-subtitle txt-font-body color-error'>
                      {error && error.message}
                    </small>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className='col-12 col-md-12 txt-center mt-2 px-0'>
            <div className='hide-absolute' aria-hidden='true'>
              {!isValid &&
                'Por favor, ' + (usernamePolicy === 'CPF' ? 'digite o seu CPF.' : 'digite o seu Login ou CPF/CNPJ.')}
            </div>
            <Button
              id='btnContinue'
              className='btn btn-sm btn-featured'
              disabled={!isValid || isLookingUpUsername}
              loading={isLookingUpUsername}
              onClick={handleContinue}
              type='button'
              text='continuar'
            />
          </div>
          {allowSignUp === 'true' && (
            <div className='col-12 col-md-12 txt-center mt-2 px-0'>
              <div className='row align-items-center h-100'>
                <p className='col txt-left txt-body-sm'>
                  <a
                    href={process.env.RAZZLE_MESSAGE_USERNAMEBOX_ALLOWSIGNUP_URL}
                    target='_blank'
                    className='txt-body-sm color-brand-2 txt-underline'
                  >
                    {process.env.RAZZLE_MESSAGE_USERNAMEBOX_ALLOWSIGNUP_TEXT}
                  </a>
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

UsernameBox.propTypes = {
  handleChange: PropTypes.func.isRequired,
  handleContinue: PropTypes.func.isRequired,
  username: PropTypes.string,
  usernamePolicy: PropTypes.string,
  allowSignUp: PropTypes.bool,
  isLookingUpUsername: PropTypes.bool,
  isHidden: PropTypes.bool,
  error: PropTypes.object
}

export default withRouter(UsernameBox)
